module.exports = __webpack_public_path__ + "img/yyrk-b3.5e738dfb.png";